// Loads Facebook avatar photos by URL into decoded ImageBitmaps.
//
// Unlike BlockBlast (which injects a bitmap into a shared ImagesHolder slot),
// SexyImagePuzzle's ImagesHolder/UIImage are ImgID/descriptor based, so we load
// per-URL bitmaps and hand them to UIImage.setImageBitmap. A small cache keyed by
// URL avoids refetching the same photo across the profile, selection grid and
// leaderboard rows.

const cache = new Map<string, Promise<ImageBitmap>>();

export function loadFacebookAvatar( url: string ): Promise<ImageBitmap>
{
  const cached = cache.get( url );
  if ( cached ) return cached;

  const promise = fetch( url )
    .then( r => r.blob() )
    .then( blob => createImageBitmap( blob ) )
    .catch( e =>
    {
      // Drop failed entries so a later attempt can retry.
      cache.delete( url );
      console.warn( '[FacebookAvatarLoader] Failed to load:', e );
      throw e;
    } );

  cache.set( url, promise );
  return promise;
}

export function clearFacebookAvatarCache(): void
{
  cache.clear();
}
